import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Logout from "@mui/icons-material/Logout";
import Typography from "@mui/material/Typography";
import { PageFrame } from "../page_frame";
import { customLogout } from "../../utils/auth";

export const UnrecognizedCustomer = () => {
  const handleLogout = async () => {
    await customLogout();
  };

  return (
    <PageFrame>
      <Box sx={{ width: "100%" }}>
        <Alert
          color="warning"
          severity="warning"
          action={
            <Button size="small" startIcon={<Logout />} onClick={handleLogout}>
              Sign Out
            </Button>
          }
        >
          We don't recognize your email address.
        </Alert>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Typography>
          If you are an Atomic client, please ensure you are signing in with
          your company email address.
        </Typography>
        <Typography>
          If you are not an Atomic client and are interested in our services,
          please <a href="mailto:neal@atomic.supply">contact us</a>.
        </Typography>
      </Box>
    </PageFrame>
  );
};
